// src/pages/PayRent.jsx
import { useLocation } from "react-router-dom";
import RentPayNow from "../components/tenant/RentPayNow";
import SetupDirectDebit from "../components/tenant/SetupDirectDebit";

export default function PayRent({ tenancy: tenancyProp }) {
  const location = useLocation();
  const state = location.state || {};

  // Support both shapes:
  // navigate("/pay-rent", { state: { tenancy } })
  // or navigate("/pay-rent", { state: tenancy })
  const tenancyFromState = state.tenancy || state;

  const tenancy =
    tenancyProp && tenancyProp.id
      ? tenancyProp
      : tenancyFromState && tenancyFromState.id
      ? tenancyFromState
      : null;

  // Fallback to query params if tenancy isn’t in props/state
  const searchParams = new URLSearchParams(location.search || "");

  const tenancyIdFromQuery = searchParams.get("tenancyId");
  const invoiceIdFromQuery = searchParams.get("invoiceId");

  const tenancyId = tenancy?.id || tenancyIdFromQuery || null;
  const invoiceId = tenancy?.invoiceId ?? invoiceIdFromQuery ?? null;

  return (
    <div className="grid gap-6">
      <section>
        <h2 className="text-xl font-semibold">Pay now (Open Banking)</h2>
        <p className="text-sm text-gray-600 mb-3">
          Instant account-to-account payment via your bank.
        </p>

        {tenancyId ? (
          <RentPayNow
            tenancyId={tenancyId}
            invoiceId={invoiceId}
          />
        ) : (
          <p className="text-sm text-red-600">
            We couldn&apos;t find enough details to start a payment. Please
            open this page from your tenant portal so we can attach it to your
            tenancy.
          </p>
        )}
      </section>

      <hr />

      <section>
        <h2 className="text-xl font-semibold">Set up Direct Debit (auto-pay)</h2>
        <p className="text-sm text-gray-600 mb-3">
          We&apos;ll collect your rent automatically each month via Bacs.
        </p>

        {tenancyId ? (
          <SetupDirectDebit
            tenancyId={tenancyId}
          />
        ) : (
          <p className="text-sm text-gray-500">
            Direct Debit setup is only available when this page is opened from a
            tenancy. Please go via your tenant portal.
          </p>
        )}

        {/* After mandate success, call /bacs/start-subscription with your rent priceId */}
      </section>
    </div>
  );
}
